var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.hasMxaCampaignOptions)?_c('label-description-toggle',{staticStyle:{"margin-top":"20px"},attrs:{"disabled":_vm.hasCampaignBeenLaunched,"value":_vm.onceEver
      ? _vm.model.enter_journey_once_ever
      : _vm.model.enter_journey_once_at_a_time,"label-text":_vm.onceEver
      ? _vm.$t('CampaignForm_Schedule_Journey_Frequency_Toggle_Once_Ever_Title')
      : _vm.$t(
          'CampaignForm_Schedule_Journey_Frequency_Toggle_Once_At_A_Time_Title'
        ),"description-text":_vm.onceEver
      ? _vm.$t(
          'CampaignForm_Schedule_Journey_Frequency_Toggle_Once_Ever_Description'
        )
      : _vm.$t(
          'CampaignForm_Schedule_Journey_Frequency_Toggle_Once_At_A_Time_Description'
        ),"info-icon":true,"tooltip-content":_vm.onceEver
      ? _vm.$t('CampaignForm_Schedule_Journey_Frequency_Toggle_Once_Ever_Tooltip')
      : _vm.$t(
          'CampaignForm_Schedule_Journey_Frequency_Toggle_Once_At_A_Time_Tooltip'
        ),"size":"medium","disabled-reason-tooltip":_vm.$t('CampaignForm_Schedule_Journey_Frequency_Toggle_Once_Disabled_Reason')},on:{"change":function($event){return _vm.onToggleChange($event)}}}):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3500ea30","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/modules/campaign-manage/components/JourneyOptionEnterOnce.vue
// module id = null
// module chunks = 